<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/jingpin/list',title:'竞品管理'},{title:'竞争对手列表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece ">
                <div class="h-formBox Dlist">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="公司名称">
							    <el-input v-model="q.companyName" placeholder="--请输入--"></el-input>
							</el-form-item>
							<el-form-item label="创建时间" class="timeselect" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="q.startdate"
										:clearable="false"
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="q.enddate"
										:clearable="false"
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item class="right-item">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
								<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
								    @click="dialogFormVisible = true">新增对手
								</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    stripe
                    style="width: 100%"
					:border="true"
					max-height="450"
                    >
                    <el-table-column
                        type="selection"
                        width="45"
                        >
                    </el-table-column>
                    <el-table-column
                        fixed
                        type="index"
                        label="#"
						width="40"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="companyName"
                        label="公司名称"
                        :show-overflow-tooltip="true"
                        >
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.companyName}}
							</div>
						</template>
                    </el-table-column>
                    <el-table-column
                        prop="brandName"
                        label="品牌名称"
                        :show-overflow-tooltip="true"
                        >
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.brandName}}
							</div>
						</template>
                    </el-table-column>
                    <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
						width="100"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="concern"
                        label="关注状态"
						width="90"
                        >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="180"
                        >
                        <template slot-scope="scope">
							<div class="w-caozuo" style="text-align: left;">
								<el-button
								     type="text"
								     size="small"
								     class="h-tableLink h-btn" @click="chakan(scope.row)">
								     查看
								 </el-button>
								 <el-button
								     type="text"
								     size="small"
								     class="h-tableLink h-btn" 
								     @click="quxiaoguanzhu(scope.row)"
								     >
								     修改状态
								 </el-button>
							</div>
                           
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="chakan(scope.row)"></span>
								<span class="l-operationlist br-operation-xg" title="修改关注状态" @click="quxiaoguanzhu(scope.row)"></span>
							</div> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                            @click="outexcel">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2" :v-if="dialogFormVisible">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>新增竞争对手</h1>
                            <p>New Competitor</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="addcom" :rules="rules" ref="addcom" :inline="true"
                        class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item label="公司名称" class="h-elformWrap-1" prop="companyName">
                            <el-input v-model="addcom.companyName" ></el-input>
                        </el-form-item>
                        <el-form-item label="品牌名称" class="h-elformWrap-1" prop="brandName">
                            <el-input v-model="addcom.brandName" ></el-input>
                        </el-form-item>
                        <el-form-item label="是否关注" prop="leltype" 
                            :rules="[{ required: true, message: '请选择是否关注', trigger: 'blur'},]" 
                            class="h-elformWrap-1">
                            <brselect category="shifou_keyong" :v="addcom.leltype" v-model="addcom.leltype"></brselect>
                        </el-form-item>
                        <el-form-item label="备注" class="h-elformWrap-1" prop="comment">
                            <el-input type="textarea" v-model="addcom.comment" class="h-txtareaBox" rows="4" :maxlength="inputMaxL"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblue2" @click="cominset('addcom')">确认提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div id="cat">
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2">
                <div class="h-dialogImgwl">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>提示信息</h1>
                            <p>{{tishixinxi}}</p>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
				inputMaxL:100,
                //提示信息框
                dialogFormVisible2: false,
                //提示信息
                tishixinxi: '',
                //表单
                formInline: {
                    customerName: '',
                    date1: '',
                    date2: '',
                    date3: '',
                    type: ''
                },
                //上部列表信息
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                //当前表信息
                tableData2: [],
                //弹框
                dialogFormVisible: false,
                addcom: {
                    companyName: '',
                    comment: '',
                    brandName: '',
                    //等级选中值
                    leltype: '',
                },
                rules: {
                    companyName: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                    brandName: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                    leltype: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                },
            }
        },
        //加载页面默认执行
        created() {
            //默认首次交互
            this.query();
        },
        //监听
        watch:{
            dialogFormVisible(val){
                //若关窗，就把资料清空
                if(val==false){
                this.$refs['addcom'].resetFields();
                this.qingkongziliao();
                }
            },
        },
        methods: {
            qingkongziliao(){
                this.addcom.companyName = '';
                this.addcom.brandName = '';
                this.addcom.comment = '';
                this.addcom.leltype = '';
                this.dialogFormVisible = false
                this.q.companyName = '';
                this.q.startdate = '';
				this.q.enddate = ''
                this.query();

            },
            //新增对手
            cominset(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                var addcom = {
                    "companyName": this.addcom.companyName,
                    "brandName": this.addcom.brandName,
                    "comment": this.addcom.comment,
                    "concern": this.addcom.leltype,
                }
                if(this.addcom.companyName&&this.addcom.brandName&&this.addcom.leltype!=""&&this.addcom.leltype!="请选择"&&this.addcom.leltype!="--选择--"&&this.addcom.leltype!=null){
                    ss.Competitors.insert(addcom).then(rd => {
                        this.tishixinxi = rd.msg;
                        this.$msg.msgs(rd.msg);
                        // this.dialogFormVisible2 = true;
                        this.qingkongziliao();
                    });
                }
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log('选择', this.multipleSelection)
            },
            //查询翻页
            query() {
                // console.log(this.q, "下面表格参数");
                ss.Competitors.getCompetitorsByTimePage(this.q).then(rd => {
                    // console.log(rd, "下面表格");
                    this.q.total = rd.total;
                    for (var t in rd.records) {
                        rd.records[t].shifouguanzhu = rd.records[t].concern == 0?false:true;
                        rd.records[t].concern = rd.records[t].concern == 0 ? '否' : rd.records[t].concern == 1 ? '是' : '';
                    }
                    this.tableData2 = rd.records;
                    console.log(rd.records, "下面表格数据");
                })
            },
            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },
            chongzhi() {
                this.q.companyName = '';
				this.q.startdate = null;
				this.q.enddate = null;
                this.query();
            },
            //导表
            outexcel() {
                //ids
                var cc = [];
                for (var d in this.multipleSelection) {
                    cc.push(this.multipleSelection[d].id);
                }
                //查询参数
                var c = {
                    companyName: this.q.companyName,
                    startdate: this.q.date[0],
                    enddate: this.q.date[1],
                    ids: cc,
                };
                console.log('导表参数', c);
                ss.Competitors.getCompetitorsForExcel(c);
            },
            //取消关注
            quxiaoguanzhu(item) {
                console.log(item,'asdasd??')
                var c = '';
                if(item.shifouguanzhu){
                    c=0;
                }else{
                    c=1;
                }
                var canshui = {
                    id:item.id,
                    concern:c,
                };
                ss.Competitors.updateById(canshui).then(rd => {
                    this.query();
                });

            },
            //点击查看详情
            chakan(item) {
                console.log('行', item)
                this.$router.push({ path:'/jingpin/detail' , query: {id: item.id}});
            }
        }
    }
</script>
<style>
    #cat .el-dialog {
        width: 30%;
    }
    #cat .h-dialogImgwl {
        height: 1.44rem;
        position: relative;
        left: -25%;
        background-size: 2.1rem;
        padding-left: 4.02rem;
    }
    .Dlist .h-formBorder .el-form-item__label{
        vertical-align: top;
    }
	/* .h-formBorder .timeselect .el-form-item__content {
	    line-height: 0.2rem;
	} */
	
	.h-formBorder .timeselect .el-date-editor .el-range-separator {
	    width: 8%;
	    line-height: 28px;
	}
	
	.h-formBorder .timeselect .el-input__inner {
	    padding-right: 0.1rem;
	}
</style>
